module.exports = __webpack_public_path__ + "static/media/live-tweet.fab235f6.png";